import { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
} from "@mui/material";
import axios from "axios";
// const COMPANY_CODE = localStorage?.getItem("companyCode") || "-";
function AddCategoryDialog({ open, onClose, onSave }) {
  const [categoryName, setCategoryName] = useState("");

  let API_PATHS = localStorage.getItem("apiPaths")
    ? JSON.parse(localStorage.getItem("apiPaths"))
    : "-";
  const BASE_URL = API_PATHS[0]?.API_CONFIG || "https://cubixweberp.com:213";

  const COMPANY_CODE = localStorage?.getItem("companyCode") || "DOODDEMO";

  const callApi = (categoryName) => {
    let url = `${BASE_URL}/api/MasterReg/ENTRY/${COMPANY_CODE}/ASSETCATEGORY/${categoryName}/612157E4-0322-4C72-AADB-F9EED849697E`;
    axios
      .post(url)
      .then((res) => {
        onSave();
        setCategoryName(""); // Reset on cancel
        onClose();
      })
      .catch((err) => {});
  };

  const handleSave = () => {
    if (categoryName.trim()) {
      callApi(categoryName.trim());
    } else {
      alert("Please enter a category name");
    }
  };

  const handleClose = () => {
    setCategoryName(""); // Reset on cancel
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>Add New Category</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          fullWidth
          label="Category Name"
          value={categoryName}
          onChange={(e) => setCategoryName(e.target.value)}
          onKeyPress={(e) => {
            if (e.key === "Enter") {
              handleSave();
            }
          }}
          margin="dense"
          size="small"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="inherit">
          Cancel
        </Button>
        <Button onClick={handleSave} variant="contained" color="primary">
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default AddCategoryDialog;
